var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.680394 4.25268C-0.269629 8.78311 2.73527 10.1096 4.74215 9.97922C4.94106 9.9663 5.10294 10.1586 5.02908 10.3533C4.65339 11.3436 3.7266 12.881 2.09726 13.4403C0.207985 14.0889 1.15262 15.512 1.8611 16.1426C3.07563 17.2235 7.41231 16.0707 9.65435 9.65716C12.9606 0.199453 2.09705 -2.503 0.680394 4.25268Z",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9026 4.25268C11.9526 8.78311 14.9575 10.1096 16.9644 9.97922C17.1633 9.9663 17.3252 10.1586 17.2513 10.3533C16.8756 11.3436 15.9488 12.881 14.3195 13.4403C12.4302 14.0889 13.3748 15.512 14.0833 16.1426C15.2979 17.2235 19.6345 16.0707 21.8766 9.65716C25.1828 0.199453 14.3193 -2.503 12.9026 4.25268Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.40ee12e9c2681c3abec7820e807a2c25.svg";
export { ForwardRef as ReactComponent };